import styled from 'styled-components';
import { BreadcrumbItem } from 'reactstrap';

import { colors, device } from 'shared/defaultTheme';

export const BreadcrumbWrapper = styled.div`
  @media ${device.sm} {
    margin-left: 0;
    .breadcrumb {
      font-size: 0.7rem;
    }
  }
  @media ${device.md} {
    margin-left: 0;
    .breadcrumb {
      font-size: 13px;
    }
  }
  @media ${device.lg} {
    margin-left: 0;
    .breadcrumb {
      font-size: 13px;
    }
  }
  @media ${device.xl} {
    margin-left: -16px;
    .breadcrumb {
      font-size: 13px;
    }
  }
  .breadcrumb {
    background-color: transparent;
    padding: 0 1rem;
  }
  .breadcrumb-item.active {
    color: ${colors.black};
    cursor: initial;
  }
  .breadcrumb-item + .breadcrumb-item::before {
    float: left;
    padding-right: 0.5rem;
    color: ${colors.noActive};
    content: '>';
  }
`;

export const BreadcrumbItemContainer = styled(BreadcrumbItem)`
  color: ${colors.noActive};
  cursor: ${({ isModify }) => (isModify ? 'initial' : 'pointer')};
`;
